export default __webpack_public_path__ + "static/media/pantry1-afterB-1024w.2abd7127.png";